import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import * as styles from './BubbleContentList.css';

interface IProps {
  data: string[];
}

export const BubbleContentList = (props: IProps) => {
  const { data } = props;

  return (
    <ul className={styles['list']}>
      {data.map((item, index) => (
        <li key={index}>
          <Body1>{item}</Body1>
        </li>
      ))}
    </ul>
  );
};
